import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      try {
        // Extract session_id from URL hash fragment
        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
          navigate('/auth', { replace: true });
          return;
        }
        const sessionId = match[1];

        // Exchange session_id for JWT via backend
        const response = await axios.post(`${API}/auth/google-session?session_id=${encodeURIComponent(sessionId)}`);
        const { access_token, user } = response.data;

        // Store in auth context (same as regular login)
        loginWithToken(access_token, user);

        // Clear the hash and redirect to client center
        window.location.hash = '';
        navigate('/client', { replace: true });
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/auth', { replace: true });
      }
    };

    processGoogleAuth();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin mx-auto mb-4" />
        <p className="text-zinc-400 text-sm">Connexion avec Google...</p>
      </div>
    </div>
  );
};
